import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router';

import { UnpublishedDropdown } from './_components/UnpublishedDropdown/UnpublishedDropdown';
import styles from './OptionsCell.module.scss';

interface IProp {
  isVersionPublished: boolean;
  id: number;
}

export const OptionsCell = ({ isVersionPublished, id }: IProp) => {
  const navigate = useNavigate();

  switch (isVersionPublished) {
    case true: {
      return (
        <Button
          className={styles['edit-button']}
          icon={<EditOutlined />}
          onClick={() => navigate(`${id}`)}
        />
      );
    }
    case false: {
      return <UnpublishedDropdown id={id} />;
    }
  }
};
